import Markdown from 'react-markdown';

import { cx } from '@libs/classnames';

import styles from './MdText.module.css';

export type Props = {
  className?: string;
  value?: string;
};

export function MdText({ className, value }: Props) {
  return (
    <div className={cx(className, styles.formattedText)}>
      <Markdown
        components={{
          a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
        }}
      >
        {value}
      </Markdown>
    </div>
  );
}
